import { GlobalStyles } from '@mui/material';

const GlobalStylesComponent = () => (
  <GlobalStyles
    styles={{
      '.wrapper': {
        width: '100%',
        // maxWidth: '1400px',
        position: 'relative',
        height: '100px',
        overflow: 'hidden',
        maskImage:
          'linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1) 20%, rgba(0, 0, 0, 1) 80%, rgba(0, 0, 0, 0))',
      },
      '@keyframes scrollLeft': {
        to: {
          left: '-200px',
        },
      },
      '.item': {
        width: '150px',
        height: '100px',
        borderRadius: '6px',
        position: 'absolute',
        left: 'max(calc(200px * 5), 100%)',
        animationName: 'scrollLeft',
        animationDuration: '30s',
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
      },
      '.item1': {
        animationDelay: 'calc(30s / 5 * (5 - 1) * -1)',
      },
      '.item2': {
        animationDelay: 'calc(30s / 5 * (5 - 2) * -1)',
      },
      '.item3': {
        animationDelay: 'calc(30s / 5 * (5 - 3) * -1)',
      },
      '.item4': {
        animationDelay: 'calc(30s / 5 * (5 - 4) * -1)',
      },
      '.item5': {
        animationDelay: 'calc(30s / 5 * (5 - 5) * -1)',
      },
      '.marquee-img': {
        width: '150px',
        height: '100px',
        objectFit: 'scale-down',
        overflow: 'auto',
      },
      '#partnerCarousel a': {
        color: '#ffffff',
      },
    }}
  />
);

export default GlobalStylesComponent;
